import * as XLSX from 'xlsx';
import dayjs from "dayjs"; // Ensure you have dayjs installed




// Function to format data for Excel export
export const exportToExcelOpenProds = (data) => {

    const columnsMapping = [
        { oldField: 'sell_price', newField: 'Preço de Venda' },
        { oldField: 'kit__kit_number', newField: 'Kit' },
        { oldField: 'product_tamanho', newField: 'Tamanho' },
        { oldField: 'kit__seller__nome', newField: 'Vendedora' },
        { oldField: 'content_type__model', newField: 'Produto' },
        { oldField: 'quantity', newField: 'Quantidade' },
        { oldField: 'kit__pay_date', newField: 'Data Acerto' },
        { oldField: 'product_id_produto', newField: 'ID Produto' },
    ];

    const desiredOrder = [
        'ID Produto',
        'Kit',
        'Vendedora',
        'Produto',
        'Tamanho',
        'Quantidade',
        'Preço de Venda',
        'Data Acerto'
    ];
    
    // Filter and map the data to include only selected columns
const filteredData = data.map((item) => {
    let newItem = {};
    desiredOrder.forEach((field) => {
        const mapping = columnsMapping.find((mapping) => mapping.newField === field);
        if (mapping) {
            if (mapping.oldField === "kit__pay_date" && item[mapping.oldField]) {
                // Format date to DD/MM/YYYY
                newItem[field] = dayjs(item[mapping.oldField]).format("DD/MM/YYYY");
            } else {
                newItem[field] = item[mapping.oldField];
            }
        }
    });
    return newItem;
});


    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Write the workbook to a blob
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create a Blob from the buffer
    const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // Generate a download link
    const link = document.createElement('a');
    link.href = URL.createObjectURL(excelBlob);
    link.download = 'Produtos.xlsx';
    link.click();
};